/** @jsxImportSource solid-js */
import { PrimaryButton } from "../button.solid";

export function SubmitButton(props: {
  disabled: boolean;
  title: string;
  onClick: () => void;
}) {
  return (
    <div class="flex items-center justify-between mt-5">
      <span></span>
      <PrimaryButton
        class="place-self-end"
        onClick={(e) => {
          e.preventDefault();
          props.onClick();
        }}
        disabled={props.disabled}
      >
        {props.title}
      </PrimaryButton>
    </div>
  );
}
